var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{attrs:{"color":"primary","rounded":"","small":"","depressed":"","loading":_vm.isSelecting},on:{"click":_vm.onButtonClick}},[_vm._t("default")],2),_c('input',{ref:"uploader",staticClass:"d-none",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.onFileChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }